import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-article-card',
  components: {},
})
export default class ArticleCard extends Vue {
  @Prop(Object) readonly item: AnyEntity;

  onActionClicked(action, row) {
    this.$emit('action-clicked', action, row);
  }

  get showPosCheckoutButton() {
    return (
      'posCheckout' in this.item.actions &&
      this.item.actions.posCheckout.activated &&
      this.item.actions.posCheckout.show &&
      this.item.in_pos
    );
  }

  get backgroundColor() {
    if (this.item.color) {
      return 'background-color: ' + this.item.color + ' !important';
    }
    return '';
  }
  get name() {
    return this.item.short_name || this.item.name;
  }

  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
